import * as R from './useProgramRecycler'

export type { ProgramRecyclerConfigResponse, UpdateProgramBenchmarkConfigRequest } from './useProgramRecycler'

export const recycler = {
  getByLiveProgramId: R.useGetByLiveProgramId,
  updateBenchmarkConfig: R.useUpdateBenchmarkConfig,
}
